var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notDataBox",staticStyle:{"color":"#666"}},[(_vm.type == 'nodata')?_c('img',{attrs:{"src":require("../../assets/img/notData.png")}}):_vm._e(),_vm._v(" "),(_vm.type == 'nosearch')?_c('img',{attrs:{"src":require("../../assets/img/No_search.png")}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"no_data_font"},[_vm._v("暂无数据")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e65a448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData/index.vue
// module id = gv0s
// module chunks = 0